<template>
  <div class="d-flex align-items-center bg-auth border-top border-top-2 border-primary">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-5 col-xl-4 my-5">
          <div class="text-center">
            <!-- Preheading -->
            <h6 class="text-uppercase text-muted mb-4">404</h6>
            <!-- Heading -->
            <h1 class="display-4 mb-3">
              BULAMADIK! 🤔
            </h1>
            <!-- Subheading -->
            <p class="text-muted mb-4">
              Üzgünüz böyle bir sayfa yok.
            </p>
            <!-- Button -->
            <router-link to="/" class="btn btn-lg btn-primary">
              Ana sayfaya dön
            </router-link>
          </div>
        </div>
      </div> <!-- / .row -->
    </div>
  </div>
</template>
<script>
import base from '@/mixins/base';
export default {
  mixins: [base],
  name: 'NotFound',
  head: {
    title: function () {
      return {
        inner: 'Aradık da Bulamadık 🤔'
      }
    },
  },
}
</script>
